// extracted by mini-css-extract-plugin
module.exports = {"Plug":"Plug_Plug__U2Fk4","Plug_na":"Plug_Plug_na__X_6i_"};